import React from 'react';
import PropTypes from 'prop-types';

function CircleCurrencyDollar(props) {
  const { height, width } = props;
  return (
    <svg
      width={width || '200'}
      height={height || '200'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.4004 6.75V8.25" stroke="#63666A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.4004 15.75V17.25" stroke="#63666A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.4004 21C17.371 21 21.4004 16.9706 21.4004 12C21.4004 7.02944 17.371 3 12.4004 3C7.42983 3 3.40039 7.02944 3.40039 12C3.40039 16.9706 7.42983 21 12.4004 21Z"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1504 15.75H13.5254C14.0227 15.75 14.4996 15.5525 14.8512 15.2008C15.2028 14.8492 15.4004 14.3723 15.4004 13.875C15.4004 13.3777 15.2028 12.9008 14.8512 12.5492C14.4996 12.1975 14.0227 12 13.5254 12H11.2754C10.7781 12 10.3012 11.8025 9.94957 11.4508C9.59793 11.0992 9.40039 10.6223 9.40039 10.125C9.40039 9.62772 9.59793 9.15081 9.94957 8.79917C10.3012 8.44754 10.7781 8.25 11.2754 8.25H14.6504"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

CircleCurrencyDollar.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

CircleCurrencyDollar.defaultProps = {
  height: undefined,
  width: 22
};

export default CircleCurrencyDollar;
